import * as React from 'react';
import styled from 'styled-components';

// Components
import {
    DatePicker,
    convertLocalToUTCDate,
    convertUTCToLocalDate
} from '../../../../../../../../../components/DatePicker';
import PlainRenderInputElement from './PlainRenderInputElement';

// Context
import { RuleEditorContext } from '../../context';

// Enums
import { dtoState } from '../../../../../../../../../common/enums/dtoState';

// Hooks
import { useCriteriaStorePredicate } from '../../../../../../../state/criteria/hooks/useCriteriaStorePredicate';
import { useCriteriaStoreUpdatePredicate } from '../../../../../../../state/criteria/hooks/useCriteriaStoreUpdatePredicate';

// Util
import { translate } from '../../../../../../../../../common/utility/DisplayPrep';

// Types
import { ruleEditorViewPartCommonProps } from '../../types';

const DateInputContainer = styled.div`
    max-width: 10rem;
`;

const DATE_PLACEHOLDER = 'date';

export const DateInput = ({ id, plainrender = true, ...props }) => {
    const { setEdited } = React.useContext(RuleEditorContext);
    const part = useCriteriaStorePredicate(id);
    const updatePredicateElement = useCriteriaStoreUpdatePredicate();

    if (plainrender) {
        return (
            <PlainRenderInputElement
                value={part?.dataInputDate1 ? translate.ReadableDateColumn(part?.dataInputDate1) : part?.dataInputDate1}
                placeholderPartial={DATE_PLACEHOLDER}
                overridable={part?.overridable}
            />
        );
    }

    return (
        <DateInputContainer>
            <DatePicker
                portalId="criteria-manager-addEdit"
                closeOnScroll={(e) => true}
                withBorder
                size={'xs'}
                id={`part_date_${id}`}
                name={`part_date_${id}`}
                selected={convertUTCToLocalDate(part?.dataInputDate1)}
                label={''}
                dateFormat="MM/dd/yyyy"
                showTimeSelect={false}
                timeFormat={''}
                withIcon
                onChange={(val) => {
                    setEdited(true);
                    updatePredicateElement({
                        ...part,
                        dtoState: dtoState.Updated,
                        dataInputDate1: convertLocalToUTCDate(val)
                    });
                }}
            />
        </DateInputContainer>
    );
};

export default DateInput;

DateInput.propTypes = {
    ...ruleEditorViewPartCommonProps
};
